export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const API_MARKETING_URL = "/api/v1/marketing";
export const API_PROMO_CODE_URL = "/api/v1/promo";
export const API_CAPTCHA_URL = "/api/v1/captcha";
export const API_LOGIN_URL = "/api/v1/users/login";
export const API_USERS_URL = "/api/v1/users";
export const FAQ_URL = `${API_MARKETING_URL}/get-faqs`;
export const PLAN_URL = `${API_MARKETING_URL}/get-plans`;
export const DEVICES_URL = `${API_MARKETING_URL}/get-device-models`;
export const COUNTRIES_STATES_URL = `${API_MARKETING_URL}/get-countries-states`;
export const PRODUCTS_URL = `${API_MARKETING_URL}/get-products`;
export const SIMILAR_PRODUCTS_URL = `${API_MARKETING_URL}/get-similar-products`;
export const COMPARE_PRODUCTS_URL = `${API_MARKETING_URL}/get-devices-comparison`;
export const PRODUCT_DETAILS_URL = `${API_MARKETING_URL}/get-product`;
export const GENERATE_CAPTCHA = `${API_CAPTCHA_URL}/generate-captcha`;
export const VALIDATE_CAPTCHA = `${API_CAPTCHA_URL}/validate-captcha`;
export const API_CART_URL = "/api/v1/cart";
export const PAY_NOW = `${API_CART_URL}/checkout`;
export const CHECKOUT_URL = `${API_USERS_URL}/checkout`;
export const UPDATE_PRODUCT = `${API_MARKETING_URL}/update-product`;
export const GET_SHIPPING_METHODS_URL = `${API_CART_URL}/get-shipping-methods`;

export const SEND_CONTACTS_URL = `${API_MARKETING_URL}/send-contact-mail`;
export const SIGN_UP_DEALER_URL = `${API_MARKETING_URL}/sign-up-dealer`;
export const SEND_FLEET_INQUIRY_URL = `${API_MARKETING_URL}/send-fleet-inquiry`;
export const LEGACY_URL =  import.meta.env.VITE_BASE_LEGACY_URL
export const LOGIN_CHECKOUT_URL = import.meta.env.VITE_BASE_URL;
export const SEARCH_DEALERS_URL = `${BASE_URL}/api/installer/search`;